import { createContext, useContext } from 'react'
import { type ReviewAnalyticsStore } from 'pages/reviews/store'

export const ReviewAnalyticsContext = createContext<ReviewAnalyticsStore | null>(null)

export function useReviewAnalyticsContext() {
  const context = useContext(ReviewAnalyticsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ReviewAnalyticsContext')

  return context
}
